import {
    FilledCard,
    RichText,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type { HeadlinePrice } from '../../../../hooks/use-config-api';
import { ConditionalComponent } from '../../../utility/ConditionalComponent';

type NonNullContents = NonNullable<HeadlinePrice['content']>;

export type PricingCardV2Props = {
    pricingCard: NonNullable<NonNullContents['pricingCard']>;
    priceNote?: NonNullContents['priceNote'] | null;
};

export const PricingCardV2 = ({
    pricingCard,
    priceNote,
}: PricingCardV2Props) => {
    return (
        <Stack gap="sm">
            <FilledCard
                withBorder
                color="primary"
                data-testid="pharmacy-pricing-card"
            >
                <Stack>
                    {pricingCard.map((line) => (
                        <RichText key={line.key} text={line.text} />
                    ))}
                </Stack>
            </FilledCard>
            <ConditionalComponent condition={!!priceNote}>
                <Stack
                    gap="xxs"
                    data-testid="pharmacy-pricing-terms-and-conditions"
                >
                    {priceNote?.map((line) => (
                        <RichText key={line.key} text={line.text} />
                    ))}
                </Stack>
            </ConditionalComponent>
        </Stack>
    );
};
